import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNfc1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="nfc-1"><path d="M6.96875 7.20751C8.13262 8.47959 8.84023 10.1589 8.84023 11.9998C8.84023 13.8407 8.13261 15.52 6.96875 16.7921M10.3402 4.73591C12.028 6.70016 13.0445 9.23394 13.0445 11.9998C13.0445 14.7656 12.028 17.2994 10.3402 19.2637M13.3495 2.52979C15.7774 5.0598 17.2487 8.37303 17.2487 11.9998C17.2487 15.6265 15.7774 18.9398 13.3495 21.4698" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconNfc1;
